import { ErrorGroup } from '../../../store/structureDefinitions/errorsState';
import ErrorGroupNotification from './ErrorGroupNotification';

const GlobalErrorNotification = () =>
    ErrorGroupNotification({
        errorGroup: ErrorGroup.Global,
    });

export default GlobalErrorNotification;
